// FranceCompanyRegistration.jsx
import React from "react";

export default function FranceCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            France Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses with France Company Registration under French corporate laws.
          </p>
          <p className="text-gray-700">
            Complete SAS/SARL incorporation through Guichet Unique portal including INPI name reservation, statutes notarization, capital deposit certification, legal notice publication, and SIREN/SIRET issuance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: France business incorporation and Greffe compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/236678/pexels-photo-236678.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="France company registration and Greffe compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless Guichet Unique and Greffe approvals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Identity proof (passport copies for directors/shareholders)</li>
                <li>Business activity details (corporate purpose and INPI classification)</li>
                <li>Address information (registered office proof and domiciliation)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Proven expertise in French SAS/SARL registrations with 100% Guichet Unique success rate and comprehensive post-incorporation compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  European Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete French corporate law knowledge including Guichet Unique processes, SAS/SARL statutes requirements, INPI name reservations, RBE beneficial owner declarations, and EU regulatory compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise statutes preparation in French, legal notice publications, capital deposit certifications, Greffe submissions, SIREN/SIRET applications, and multi-jurisdiction document coordination ensuring first-time approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from INPI name approval through Kbis extract issuance, URSSAF/CFE registrations, VAT activation, corporate bank setup, payroll compliance, and first-year French regulatory advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
